
import LayoutContent from '../../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../../helpers/indexedDbHelper';
import ListProducts from '../ListProducts';

function Index({dishs2, setShowBar}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showSpecialitylCocktail, setShowSpecialitylCocktail] = useState(false);
    const [showSesonalCocktail, setShowSesonalCocktail] = useState(false);
    const [showPeruvianClasic, setshowPeruvianClasic] = useState(false);
    const [showBeer, setshowBeer] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [showspirits, setShowSpirits] = useState(false);
    const [signature, setSignature] = useState(false);
    const [vip, setvip] = useState(false);
    const [datawine, setdatawine] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 387) {
                setSignature(item);
            }
            if (item.id === 399) {
                setvip(item);
            }
           
        });
    }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showImageTop={true} showBack={true} setShowSpecials={setShowSpecials} goHome={setShowBar} setShowListProduct={setShowBar}>
                <div style={{ padding: '0 10px', paddingLeft: 40 }}>
                    
                     <p style={{color: 'white', textAlign: 'center', fontSize: 40, fontWeight: '900', textTransform: 'uppercase'}}>
                      cocktails / cocteles
                    </p>

                    <div
                        style={{
                            display: 'flex',
                            marginTop: 20,
                            flexDirection: 'column',
                            alignSelf: 'center',
                            justifyContent: "center",
                            alignItems: 'center',
                            gap: 30
                        }}>
                        <div
                            onClick={() => {
                                setdishs(signature);
                                setShowListProduct(true)
                            }}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                width: 350,
                                height: 70,
                                background: 'white',
                                border: '1px solid #FEBA29',
                                boxShadow: '5px 5px 2px 0px #ED3E08'
                        }}>
                           
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: '#ED3E08', textAlign: 'center', fontSize: 45,fontFamily:"Watchtower"}}>
                                    signature cocktails
                                </p>
                               
                            </div>
                        </div>

                       <div
                            onClick={() => {
                                setdishs(vip);
                                setShowListProduct(true)
                            }}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                width: 350,
                                height: 70,
                                background: 'white',
                                border: '1px solid #FEBA29',
                                boxShadow: '5px 5px 2px 0px #ED3E08'
                        }}>
                           
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: '#ED3E08', textAlign: 'center', fontSize: 45,fontFamily:"Watchtower"}}>
                                    vip coctails
                                </p>
                               
                            </div>
                        </div>
                    </div>

                </div>
               
                 {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;